import { IconeProprio, type PropsIcone } from './base'

/**
 * Ícones das vistas de câmera. São desenhados aqui, e não tirados da biblioteca,
 * porque precisam formar um conjunto legível entre si: o mesmo cubo isométrico,
 * com a face correspondente destacada. Um ícone genérico de "frente" e outro de
 * "topo" vindos de famílias diferentes não se leem como quatro opções do mesmo
 * controle.
 */

const CUBO = 'M12 3l8 4.5v9L12 21l-8-4.5v-9z'
const ARESTA_ESQ = 'M4 7.5l8 4.5'
const ARESTA_DIR = 'M20 7.5l-8 4.5'
const ARESTA_VERT = 'M12 12v9'

function Cubo({ destaque }: { destaque: React.ReactNode }) {
  return (
    <>
      {/* A face destacada vem ANTES do contorno para que o traço do cubo fique
         por cima dela: a 18px o preenchimento precisa ser forte para as quatro
         vistas se distinguirem, e sem o contorno por cima a forma se perde. */}
      {destaque}
      <path d={CUBO} />
      <path d={ARESTA_ESQ} opacity="0.4" />
      <path d={ARESTA_DIR} opacity="0.4" />
      <path d={ARESTA_VERT} opacity="0.4" />
    </>
  )
}

/** Vista frontal: face da frente do cubo preenchida. */
export const IconeVistaFrontal = (p: PropsIcone) => (
  <IconeProprio {...p}>
    <Cubo destaque={<path d="M4 7.5l8 4.5v9l-8-4.5z" fill="currentColor" opacity="0.85" />} />
  </IconeProprio>
)

/** Vista lateral: face do lado direito preenchida. */
export const IconeVistaLateral = (p: PropsIcone) => (
  <IconeProprio {...p}>
    <Cubo destaque={<path d="M20 7.5l-8 4.5v9l8-4.5z" fill="currentColor" opacity="0.85" />} />
  </IconeProprio>
)

/** Vista superior: face de cima preenchida. */
export const IconeVistaSuperior = (p: PropsIcone) => (
  <IconeProprio {...p}>
    <Cubo destaque={<path d="M12 3l8 4.5-8 4.5-8-4.5z" fill="currentColor" opacity="0.85" />} />
  </IconeProprio>
)

/** Vista isométrica: o cubo inteiro, sem face privilegiada. */
export const IconeVistaIsometrica = (p: PropsIcone) => (
  <IconeProprio {...p}>
    <Cubo destaque={null} />
  </IconeProprio>
)
